module.exports = __webpack_public_path__ + "static/media/BOSCHLTD.84b88691.txt";